import { render, staticRenderFns } from "./reprintDialog2.vue?vue&type=template&id=57b04994&scoped=true&"
import script from "./reprintDialog2.vue?vue&type=script&lang=js&"
export * from "./reprintDialog2.vue?vue&type=script&lang=js&"
import style0 from "./reprintDialog2.vue?vue&type=style&index=0&id=57b04994&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b04994",
  null
  
)

export default component.exports